
import { DBAuthProfile, DBRole } from './DBEnum'

export const GlbSwVersionCollectionName = 'swVersion'
export const GlbUserCollectionName = 'user'
export const GlbCompanyCollectionName = 'company'
export const GlbUsercompanyCollectionName = 'usercompany'
export const GlbRegistryCollectionName = 'registry'
export const GlbCompanyAuthCollectionName = 'companyauth'
export const GlbMaintenanceCollectionName = 'maintenance'

export const GlbRolesAllUser = [ DBRole.USER, DBRole.TEAMLEADER, DBRole.ADMIN, DBRole.SUPERADMIN ]
export const GlbRolesAllBackOffice = [ DBRole.ADMIN, DBRole.TEAMLEADER, DBRole.SUPERADMIN ]
export const GlbRolesAllAdmin = [ DBRole.ADMIN, DBRole.SUPERADMIN ]
export const GlbRolesTeamLeaderAndUp = [ DBRole.TEAMLEADER, DBRole.ADMIN, DBRole.SUPERADMIN ]
//export const GlbRolesTeamLeaderKioskAndUp = [DBRole.TEAMLEADER, DBRole.ADMIN, DBRole.SUPERADMIN]
export const GlbRolesSuperAdmin = [ DBRole.SUPERADMIN ]

export const GlbAuthProfileAll = [ DBAuthProfile.CLIENT, DBAuthProfile.MANAGER, DBAuthProfile.SELLER ]
export const GlbAuthProfileInternal = [ DBAuthProfile.MANAGER, DBAuthProfile.SELLER ]
export const GlbAuthProfileManager = [ DBAuthProfile.MANAGER ]

export const GlbDefaulPageSize = 200

export const GlbDefaultPageSizeOptions = [  50, 100, 200 ]
export const GlbDefaultItemsPerPage = 50

export const GlbAll = 'ALL'
export const GlbOtherColor = 'Glb-OTHER'
//export const GlbMinDate = new Date(-8640000000000000);
export const GlbMinDate = new Date( 0 )
export const GlbMaxDate = new Date( 9999, 11, 31 )

export const GlbAvailableColor = [
  'primary',
  '#F44336',
  '#E91E63',
  '#9C27B0',
  '#673AB7',
  '#3F51B5',
  '#2196F3',
  '#03A9F4',
  '#00BCD4',
  '#009688',
  '#4CAF50',
  '#8BC34A',
  '#CDDC39',
  '#FFC107',
  '#FF9800',
  '#FF5722',
  '#795548',
  '#9E9E9E',
  '#607D8B',
  '#69F0AE',
  '#FF1744',
  '#F50057',
  '#D500F9',
  '#651FFF',
  '#3D5AFE',
  '#2979FF',
  '#00B0FF',
  '#00E5FF',
  '#1DE9B6',
  '#00E676',
  '#76FF03',
  '#C6FF00',
  '#FFEA00',
  '#FFC400',
  '#FF9100',
  '#FF3D00',
  '#FF6E40',
  '#EA80FC',
  '#B388FF',
  '#8C9EFF',
  '#82B1FF',
  '#80D8FF',
  '#A7FFEB',
  '#B9F6CA',
  '#CCFF90',
]

